const API_URL = process.env.REACT_APP_API_URL;

let apiUrls =  {
    elements: `${API_URL}/saddle-wire-stitching-machines`,
    saveSpeedTable: `${API_URL}/saddle-wire-stitching-machine/save-speed-table`
};

export default apiUrls;
